<app-homepage
    [viewEventi]="viewEventi"
    [viewReservation]="viewReservation"
    [viewSettings]="viewSettings"
></app-homepage>
